// extracted by mini-css-extract-plugin
module.exports = {"paged":"Paginado_paged__3uPBX","numbers":"Paginado_numbers__3CuPl","active":"Paginado_active__18aw4"};